import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { TimeApprovalsPage } from "@/features/timeapprovals/TimeApprovalsPage";

const search = z.object({
  id: z.string().optional(),
  view: z.enum(["submitted", "approved", "rejected", "all"]).optional(),
});

export const Route = createFileRoute("/_app/time/approvals")({
  validateSearch: search,
  component: () => <TimeApprovalsPage search={Route.useSearch()} />,
});
